import {
    ReactElement,
    cloneElement,
    useId,
    useMemo,
    useRef,
    useState,
    useEffect,
} from 'react';
import ReactModal from 'react-modal';
import useWidth from '../../hooks/useWidth';
import WalletDropdownContainer from './WalletDropdownContainer';
import { useWeb3React } from '@web3-react/core';
import useModalState from '../../context/modal/useModalState';

type WalletDropdownProps = {
    trigger: ReactElement;
};

const WalletDropdown: React.FC<WalletDropdownProps> = ({ trigger }) => {
    const uuid = useId();

    const triggerRef = useRef<HTMLButtonElement>();

    const windowWidth = useWidth();

    const { account } = useWeb3React();
    const { modal, openModal, closeModal } = useModalState();

    const [position, setPosition] = useState({ x: 0, y: 0 });

    const otherModalOpen = Object.values(modal).includes(true);

    const handleClose = () => {
        closeModal('walletDropdown');
    };

    const clonedTrigger = useMemo(
        () =>
            cloneElement(trigger, {
                ref: triggerRef,
                id: uuid,
                onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
                    if (account) {
                        e.stopPropagation();
                        openModal('walletDropdown');
                    } else {
                        openModal('connectWalletModal');
                    }
                },
            }),

        [trigger, uuid, account, openModal]
    );

    useEffect(() => {
        const triggerEle = triggerRef.current;

        if (triggerEle) {
            const { right, bottom } = triggerEle.getBoundingClientRect();

            const offsetY = 32;

            setPosition({ x: right, y: bottom + offsetY });
        }
    }, [triggerRef, windowWidth]);

    return (
        <>
            <ReactModal
                ariaHideApp={false}
                isOpen={modal['walletDropdown']}
                shouldCloseOnOverlayClick
                onRequestClose={handleClose}
                overlayClassName='wallet-dropdown-overlay'
                className='wallet-dropdown'
                onAfterOpen={() => (document.body.style.overflow = 'hidden')}
                onAfterClose={() =>
                    !otherModalOpen && (document.body.style.overflow = 'unset')
                }
                style={{
                    content: {
                        left: position.x,
                        top: position.y,
                    },
                }}
            >
                <WalletDropdownContainer />
            </ReactModal>
            {clonedTrigger}
        </>
    );
};

export default WalletDropdown;
